module.exports = __webpack_public_path__ + "img/LBA-Statistik.f483244e.svg";